import { APIModel } from "../api-model";
import { FinalDisposition } from "../final-disposition";

export class MatchCalculatedStats extends APIModel {
  first_recipient_name: { last_name: string, first_name: string };
  first_recipient_full_name: string;
  total_recipients: string;
  total_refused_offers: string;
  total_bypassed_offers: string;
  first_seq: string;
  first_refused_seq: string;
  first_bypassed_seq: string;
  first_blank_seq: string;
  first_py_seq: string;
  first_accepted_seq: string;
  first_accepted_organ: string;
  second_accepted_seq: string;
  second_accepted_organ: string;
  first_accepted_any_tc: { tc: string; seq: number; organ: string } | null;
  second_accepted_any_tc: { tc: string; seq: number; organ: string } | null;
  first_accepted_current_tc: { tc: string; seq: number; organ: string } | null;
  second_accepted_current_tc: { tc: string; seq: number; organ: string } | null;
  service_level: string;
  service_level_error: string;
  applicable_service_level: string;
  notified: string;
  primary_notified: string;
  backup_notified: string;

  final_disposition_notes: string;
  final_disposition_notes_override: string;
  final_disposition_notes_applicable: string;

  final_disposition: FinalDisposition;
  final_disposition_override: FinalDisposition;
  final_disposition_applicable: FinalDisposition;

  declined_recipient_details: [];
  unique_decline_codes_1_refused: [];
  unique_decline_codes_2_refused: [];
  unique_decline_codes_1_bypassed: [];
  unique_decline_codes_2_bypassed: [];

  accepted: boolean | undefined;
  declined: boolean | undefined;
  cross_clamp_time_passed: boolean | undefined;

  static fieldsToMap = {
    direct: [
      'first_recipient_name',
      'total_recipients',
      'total_refused_offers',
      'total_bypassed_offers',
      'first_seq',
      'first_refused_seq',
      'first_bypassed_seq',
      'first_blank_seq',
      'first_py_seq',
      'first_accepted_seq',
      'first_accepted_organ',
      'second_accepted_seq',
      'second_accepted_organ',
      'service_level',
      'service_level_error',
      'applicable_service_level',
      'final_disposition_notes',
      'final_disposition_notes_override',
      'final_disposition_notes_applicable',
      'final_disposition',
      'final_disposition_override',
      'final_disposition_applicable',
      'accepted',
      'declined',
      'cross_clamp_time_passed'
    ],
    arrays: [
      'declined_recipient_details',
      'unique_decline_codes_1_refused',
      'unique_decline_codes_2_refused',
      'unique_decline_codes_1_bypassed',
      'unique_decline_codes_2_bypassed',
      'users_who_made_changes'
    ],
    booleanYesNo: [
      'notified',
      'primary_notified',
      'backup_notified',
    ]
  }

  static buildFromAPI(record: any): MatchCalculatedStats {
    const row = new MatchCalculatedStats();
    record = record || {};

    this.mapFieldsDirectly<MatchCalculatedStats>(MatchCalculatedStats.fieldsToMap.direct, record, row);
    this.mapArrays<MatchCalculatedStats>(MatchCalculatedStats.fieldsToMap.arrays, record, row);
    this.mapBooleanYesNo<MatchCalculatedStats>(MatchCalculatedStats.fieldsToMap.booleanYesNo, record, row);

    row.first_recipient_full_name = this.calculate_first_recipient_full_name(record.first_recipient_name);
    row.first_accepted_any_tc = this.calculate_accepted_any_tc(record.first_accepted_any_tc);
    row.second_accepted_any_tc = this.calculate_accepted_any_tc(record.second_accepted_any_tc);
    row.first_accepted_current_tc = this.calculate_accepted_any_tc(record.first_accepted_current_tc);
    row.second_accepted_current_tc = this.calculate_accepted_any_tc(record.second_accepted_current_tc);
    row.accepted = record.calculated_state == "accepted"
    row.declined = record.calculated_state == "declined"

    return row;
  }

  static calculate_first_recipient_full_name(nameObj) {
    if (!nameObj) return '';
    return [nameObj.last_name?.trim(), nameObj.first_name?.trim()].join(', ')
  }
  static calculate_birthsex(record) {
    return record.birthsex || record.gender;
  }
  static calculate_accepted_any_tc(acceptedObj): { tc: string; seq: number; organ: string } | null {
    if (!acceptedObj) {
      return null;
    }
    return {
      tc: acceptedObj.tc ? acceptedObj.tc : 'Unknown',
      seq: acceptedObj.seq,
      organ: acceptedObj.organ
    };
  }

}